/* eslint-disable no-unused-vars */
import { Form, Checkbox } from 'antd';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import DokanIcons from '../icon/DokanIcons';

/* Title: Generics Checkbox component
 * Description:
 * Author: Majeed
 * Date: 2021-10-13
 */

/**
 * @param  {} {children}
 * @param { label }
 * @param { value }
 * @param { icon }
 * @param {boolean} {isIcon}
 */
const DokanCheckBox = ({
    label,
    checkValue,
    isIcon,
    icon,
    FormInputName,
    FormInputLabel,
    FormInputRules,
    onValueChange,
    children,
}) => {
    const [checkVal, setChecked] = useState(true);
    // Handle checkbox....
    const changeInputField = (name, value) => {
        console.log('checkbox', name, value);
        onValueChange(name, value);
    };

    const getInputData = useSelector((state) => state.products.productInputData);
    const InputData = { ...getInputData };
    const setInputData = InputData[FormInputName];

    return (
        <Form.Item name={FormInputName} label={FormInputLabel} rules={FormInputRules}>
            <div className="grid gap-y-1 justify-between min-w-full">
                <div className="flex flex-1 pt-4">
                    <div>
                        <Checkbox
                            className="dokan-checkbox"
                            checked={setInputData}
                            onChange={(e) => changeInputField(FormInputName, e.target.checked)}
                        >
                            <span className="text-sm font-light">{label}</span>
                        </Checkbox>
                    </div>
                    {isIcon && (
                        <div className="mt-1">
                            <DokanIcons icon={icon} size="3" />
                        </div>
                    )}
                </div>
            </div>
        </Form.Item>
    );
};

export default DokanCheckBox;
